import styled from 'styled-components';
import PropTypes from "prop-types";
import { device } from "../device";

const H3 = styled.h3`
    font-size: 32px;
    font-weight: 500;
    line-height: 1.2;
    margin: 0;

    padding: ${({space}) => 
        (space === 'Top' && '88px 0 0') ||
        (space === 'TopDown' && '88px 0 32px') || 
        (space === 'Down' && '0 0 32px') || 
        '0'
    };

    @media ${device.lg} {
        font-size: 48px;
    }
`;

H3.propTypes = {
    space: PropTypes.string
};

export default H3;